module.exports = __webpack_public_path__ + "img/89.2fb575f5.svg";